<!--
    This component imitates an in-page <a href="#foo"></a> element.
    It attempts to override the "jump" behavior with a smooth scroll.

    Example markup:

        <scroll-anchor :href="#content-element">
            <i>Jump to content</i>
        </scroll-anchor>

        ...
        
        <div id="content-element"></div>
-->

<template>
    <a class="scroll-anchor" :href="targetElementSelector" @click="scroll">
        <slot>
            Jump to {{targetElementSelector}}
        </slot>
    </a>
</template>

<script>
    export default {
        name: 'scroll-anchor',
        props: {
            href: {
                // The ID of the target element
                type: String,
                required: true
            }
        },
        computed: {
            targetElementId() {
                return this.href.startsWith('#') ? this.href.substring[0] : this.href;
            },
            targetElementSelector() {
                return '#' + this.targetElementId;
            },
            targetElement() {
                return document.getElementById(this.targetElementId);
            }
        },
        methods: {
            scroll(event) {
                try {
                    this.targetElement.scrollIntoView({ behavior: 'smooth' });
                    event.preventDefault();
                } catch (ex) {
                    // If we fail to scroll, we also fail to prevent default.
                    // So, no action necessary.
                }
            }
        }
    };
</script>